import { useState } from "react";

import Tabs from "../../components/Tabs";
import AvatarHome from "../../components/AvatarHome";
import ReportCSCM from "../../components/report/ReportCSCM";
import NextClassCSCM from "../../components/TableClass/NextClassCSCM";
import CustomerService from "../../pages/CustomerService/CustomerServiceHomeCSCM";
import ClassesWithoutTeacher from "../../components/TableClass/ClassesWithoutTeacher";

const HomeCustomerService = () => {
  const [activeTab, setActiveTab] = useState("CHECK_IN");

  const options = ["CHECK_IN", "BTN_CLASS_WITHOUT_TECHER", "CUSTOMER_SERVICE", "REPORT_FORM"];

  return (
    <div className="containerHomeCompanyManager">
      <AvatarHome buttonUpdate />

      <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
        {options[0] === activeTab && <NextClassCSCM />}
        {options[1] === activeTab && <ClassesWithoutTeacher />}
        {options[2] === activeTab && <CustomerService />}
        {options[3] === activeTab && <ReportCSCM />}
      </Tabs>
    </div>
  );
};

export default HomeCustomerService;
